<template>
  <v-card>
    <slot />
  </v-card>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Card",
  props: ["title", "color"],
  data() {
    return {};
  },
});
</script>
